import { Fragment } from "react";

import type { DocsRichRun, DocsRichText } from "@/presentation/data/docs/docs-content.types";

interface DocsRichTextProps {
  value: DocsRichText;
}

/** Renders inline rich text (plain strings, inline `code`, `strong`, and link runs). */
export function DocsRichTextView({ value }: DocsRichTextProps) {
  const runs: DocsRichRun[] = Array.isArray(value) ? value : [value];
  return (
    <>
      {runs.map((run, i) => (
        <Fragment key={i}>{renderRun(run)}</Fragment>
      ))}
    </>
  );
}

function renderRun(run: DocsRichRun) {
  if (typeof run === "string") return run;
  if ("code" in run) {
    return (
      <code className="bg-muted text-foreground rounded px-1.5 py-0.5 font-mono text-[0.85em]">
        {run.code}
      </code>
    );
  }
  if ("href" in run) {
    const external = /^https?:\/\//.test(run.href);
    return (
      <a
        href={run.href}
        {...(external ? { target: "_blank", rel: "noreferrer noopener" } : {})}
        className="text-[oklch(0.6_0.13_190)] underline decoration-[oklch(0.6_0.13_190_/_0.4)] underline-offset-2 transition-colors hover:decoration-[oklch(0.6_0.13_190)]"
      >
        {run.text}
      </a>
    );
  }
  return <strong className="font-semibold">{run.strong}</strong>;
}
